<template>
    <div class="container">
        <div v-if="item" class="list_box" >
                       <img v-if="item.templateType ==1" class="list_box_bg" src="../../assets/images/img_ticket_center.png"/>
                       <img v-else class="list_box_bg" src="../../assets/images/img_ticket_fanjin.png"/>
                       <!-- <img v-else class="list_box_bg" src="../../assets/images/img_ticket_grayBG.png"  /> -->
                       <div class="list_box_left" >
                           <div v-if="item.templateType ==1" :class="['list_box_left_div1', activeTab!=0 ? 'grayClass':'greenClass' ]">
                               <span class="list_box_left_span1">{{typeName}}</span>
                           </div>
                           <div v-else :class="['list_box_left_div2', activeTab!=0 ? 'grayClass':'yellowCloss' ]">
                               <span :class="['list_box_left_span2', activeTab!=0 ? 'whiteClass':'blackClass' ]" >{{typeName}}</span>
                           </div>
                           <div v-if="item.discountMode == '1'" class="list_box_left_body">
                                   <span :class="['list_box_left_body_span1', activeTab!=0 ? 'grayTextClass':'redTextClass' ]" >￥</span>
                                   <span :class="['list_box_left_body_span2', activeTab!=0 ? 'grayTextClass':'redTextClass' ]">{{item.amountDiscount}}</span>
                           </div>
                           <div v-else class="list_box_left_body">
                                   <span :class="['list_box_left_body_span2', activeTab!=0 ? 'grayTextClass':'redTextClass' ]">{{item.amountDiscount/10}}</span>
                                   <span  :class="['list_box_left_body_span3', activeTab!=0 ? 'grayTextClass':'redTextClass' ]" >折</span>
                           </div>
                       </div>
                       <div class="list_box_right" >
                            <span class="list_box_right_span1">{{item.name}}</span>
                            <span class="list_box_right_span2">{{item.beginTime | date}}-{{item.endTime | date}}</span>
                            <span class="list_box_right_span3">{{item.templateDescr}}</span>

                       </div>
                       <!-- <div v-if="activeTab==0" class="useDiv">
                            <span class="useDiv_span">去使用</span>
                       </div> -->
                       <img class="usedImg" v-if="activeTab==1" src="../../assets/images/icon_ticket_used.png"/>
                       <img class="usedImg" v-else-if="activeTab==2" src="../../assets/images/icon_ticket_expired.png"/>
        </div>

        <div v-if="item.templateType ==1 && link" class="couponDetails_touse_button" @click="toUse">
              <span class="touse_button_span">去使用</span>
        </div>
        <div v-if="item.templateType ==3" class="qrCodeDiv">
            <span class="qrCode_span1">请到店出示券码</span>
            <div  class="qrCode_icon" ref="qrCodeUrl"></div>
            <span class="qrCode_span2">{{code}}</span>
        </div>
        <div class="grayLine"></div>
        <div class="couponDetails_titleDiv" >
            <div class="couponDetails_titleDiv_span1"></div>
            <span class="titleDiv_span2">有效期</span>
        </div>
        <div class="messageDiv">
            <span class="messageDiv_span">{{item.beginTime | date}}-{{item.endTime | date}}</span>
        </div>

        <div class="couponDetails_titleDiv" >
            <div class="couponDetails_titleDiv_span1"></div>
            <span class="titleDiv_span2">使用条件</span>
        </div>
         <div class="messageDiv">
            <span class="messageDiv_span">{{item.activeDescr ||item.descr}}</span>
        </div>
        <div class="couponDetails_titleDiv" >
            <div class="couponDetails_titleDiv_span1"></div>
            <span class="titleDiv_span2">使用说明</span>
        </div>
         <div class="messageDiv">
            <span class="messageDiv_span">券类型: {{typeName}}</span>
            <span class="messageDiv_span">适用业主: {{item.cityName}}</span>
            <span class="messageDiv_span" v-if="item.marketName" >适用项目: {{item.marketName}}</span>
        </div>
         <div class="couponDetails_titleDiv" >
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import QRCode from 'qrcodejs2'
import {getMbBondTemplateById,getMbBondActiveById,getBondDict} from "../../utils/api";
export default {
  name: "myCoupon",
  components: {
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  data() {
    return {
      HT:"全部卡券",
      activeTab:0,
      index:1,
      qrcodeTool:'',
      templateId:'',
      id:'',
      code:'',
      link:'',
      item:'',
      HTList:'',
      typeName:'',

    }
  },
  created(){
      let params =this.$route.params;
      this.activeId =params.id;
      let query = this.$route.query;
      this.templateId = query.templateId
      this.code = query.code;
      this.id = query.id;
      if(query.link &&query.link.length>0){
        this.link =decodeURIComponent(query.link);
      }

      this.getMbBondActiveById();
    //   this.getMbBondTemplateById()
  },
  filters: {
      date: function(data) {
        if (data) {
          return data.split('-').join('.')
        }
      }
  },
  methods: {
      toUse(){
          if(this.link){
              this.$router.push({
                path:"/"+ this.link
            })
          }
      },

    getMbBondActiveById () {
        let params = {
            activeId: this.activeId
        };
        var self =this;
        getMbBondActiveById(params).then(res => {
            console.log(res)
            if (res.res.code === 10000 && res.body.mbBondActive) {
                this.item = res.body.mbBondActive
                if(this.item.templateType ==3){
                        setTimeout(() => {
                                self. getTenantQrCode();
                        }, 100)
                }
                this.getBondDict();
            } else {
                this.getMbBondTemplateById()
            }
        });
    },

      getMbBondTemplateById(){
            var self =this;
            var param ={
                // activeId:this.templateId
                "templateId": this.templateId
            }
            getMbBondTemplateById(param).then(res => {
                if (res.res.code === 10000) {
                    this.item = res.body.MbBondTemplate
                    if(this.item.templateType ==3){
                            setTimeout(() => {
                                self. getTenantQrCode();
                            }, 100)
                        }
                    this.getBondDict();
                }
            });
      },
      getBondDict() {
        getBondDict({}).then(res => {
          if (res.res.code === 10000) {
                var list = res.body.dictList;
                var allList =[];
                var allItem ={"dictName":"全部卡券","dictValue":''};
                allList.push(allItem);
                this.HTList = [...allList, ...list];
                for(var i =0;i<this.HTList.length;i++){
                    if(this.item.templateType){
                        if(this.item.templateType ==this.HTList[i].dictValue){
                            this.typeName =this.HTList[i].dictName

                        }
                    }else{
                         if(this.item.type ==this.HTList[i].dictValue){
                            this.typeName =this.HTList[i].dictName
                        }

                    }
                }
          }
        });
      },
          //获取二维码数据
      getTenantQrCode() {
            let content = {
                'itemId': this.id,
                'itemCode': this.code,
                'orderType': 3
            }
            this.creatQrCode(JSON.stringify(content));
      },

      //js生成二维码
      creatQrCode(dic) {
        //{qrcode:code}  ;
        if(!this.qrcodeTool){
           var wh =document.body.clientWidth;
           var w =150*wh/375;
           var h =150*wh/375;
           this. qrcodeTool = new QRCode(this.$refs.qrCodeUrl, {
                    text: dic,
                    //JSON.stringify(map).replace(/(\")/g,"\\$1"),
                    width: w,
                    height: h,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.M
            })
        }else{
            this.qrcodeTool.clear(); // 清除代码
            this.qrcodeTool.makeCode(dic); // 生成另外一个二维码
        }
      },
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    // width:100%;
    // height: 100vh;
    position: relative;
    background:rgba(255,255,255,1);
    .flex(column);
}
.list_box{
    height: 200px;
    width: 94.6%;
    // background-color: aqua;
    margin-top: 40px;
    margin-left: 20px;
    position: relative;
    flex-direction: row;

    .list_box_bg{
        left: 0;
        top: 0;
        position: absolute;
        height: 200px;
        width: 100%;
        z-index: 1;
    }
    .list_box_left{
        left: 0;
        top:0;
        position: absolute;
        height: 200px;
        width: 25%;
        // background-color: antiquewhite;
        z-index: 100;
        flex-direction: column;
        .list_box_left_div1{
            display: flex;
            width:100px;
            height:40px;
          //  background:rgba(22,188,132,1);
            border-radius:8px 0px 8px 0px;
            justify-content: center;
            justify-items: center;
            align-items: center;
            .list_box_left_span1{
                text-align: center;
                font-size:24px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:24px;
            }

        }
        .list_box_left_div2{
            display: flex;
            width:100px;
            height:40px;
           // background:rgba(246,196,0,1);
            border-radius:8px 0px 8px 0px;
            justify-content: center;
            justify-items: center;
            align-items: center;
            .list_box_left_span2{
                text-align: center;
                font-size:24px;
                font-weight:500;
                line-height:24px;
            }

        }
          .list_box_left_body{
                width: 100%;
                display: flex;
                margin-top: 30px;
                justify-content: center;
                flex-direction: row;
                align-items: flex-start;
                .list_box_left_body_span1{
                    height:40px;
                    font-size:28px;
                    font-weight:500;
                    // color:rgba(252,63,86,1);
                    line-height:40px;
                }
                .list_box_left_body_span2{
                    height:60px;
                    font-size:56px;
                    font-weight:500;
                    // color:rgba(252,63,86,1);
                    line-height:60px;
                }
                 .list_box_left_body_span3{
                    margin-top: 30px;
                    height:28px;
                    font-size:28px;
                    font-weight:500;
                    // color:rgba(252,63,86,1);
                    line-height:28px;
                }

            }

    }
    .list_box_right{
        right: 25%;
        top: 0;
        position: absolute;
        flex-direction: column;
        height: 200px;
        width: 50%;
        z-index: 100;
        .list_box_right_span1{
            margin-left: 20px;
            margin-top: 28px;
            display: flex;
            width: 90%;
            height:42px;
            font-size:30px;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:42px;
        }
        .list_box_right_span2{
            margin-left: 20px;
            margin-top: 30px;
            display: flex;
            width: 90%;
            height:28px;
            font-size:22px;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:28px;

        }
        .list_box_right_span3{
            margin-left: 20px;
            margin-top: 4px;
            display: flex;
            width: 90%;
            height:28px;
            font-size:22px;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:28px;
        }
    }
    .grayClass{
        background: #DADADA;
    }
    .greenClass{
        background:rgba(22,188,132,1)
    }
    .yellowCloss{
        background:rgba(246,196,0,1);
    }
    .blackClass{
        color:#333333;
    }
    .whiteClass{
        color: #ffffff;
    }
    .grayTextClass{
        color: #999999;
    }
    .redTextClass{
        color:rgba(252,63,86,1);
    }

    .useDiv{
        right: 26px;
        top: 120px;
        position: absolute;
        width:128px;
        height:52px;
        display: flex;
        background:rgba(255,255,255,1);
        border-radius:4px;
        justify-content: center;
        justify-items: center;
        align-items: center;
        z-index: 101;
        .useDiv_span{
            height:32px;
            font-size:26px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:32px;
        }
    }
    .usedImg{
        position: absolute;
        z-index: 101;
        right: 26px;
        top: 40px;
        width: 120px;
        height: 120px;
    }


    //pop view


}
.couponDetails_touse_button{
    margin-top: 60px;
    display: flex;
    margin-left: 28px;
    width: 92.53%;
    height:76px;
    background-color:@color17;
    border-radius:4px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    .touse_button_span{
        height:44px;
        font-size:32px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:44px;
    }
}
.qrCodeDiv{
    margin-top: 60px;
    display: flex;
    flex-direction: column;
    justify-items: center;
    justify-content: center;
    align-items: center;
    align-content: center;
    .qrCode_span1{
        height:40px;
        font-size:36px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:40px;
    }
    .qrCode_icon{
        margin-top: 60px;
        width: 300px;
        height: 300px;
    }
    .qrCode_span2{
        margin-top: 36px;
        padding-left: 24px;
        padding-right: 24px;
        height:56px;
        background:rgba(248,248,248,1);
        border-radius:28px;
        font-size:28px;

        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:56px;

    }
}
.grayLine{
    margin-left: 28px;
    margin-top: 60px;
    width: 92.53%;
    display: flex;
    height:1px;
    background:rgba(234,234,234,1);
}
.couponDetails_titleDiv{
    flex-direction: row;
    // background-color: palevioletred;
    width: 92.53%;
    margin-top: 60px;
    margin-left: 28px;
    display: flex;
     align-items: center;
   .couponDetails_titleDiv_span1{
        width:6px;
        height:24px;
        background-color:@color17
    }
    .titleDiv_span2{
        margin-left: 12px;
        height:44px;
        font-size:32px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:44px;

    }

}
.messageDiv{
    flex-direction: column;

    margin-left: 28px;
    width: 92.53%;
    // background-color: red;
    .messageDiv_span{
        width:100%;
        // background-color: orange;
         display: flex;
         margin-top: 20px;
        font-size:28px;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:40px;
    }
}


</style>